import ShineGame from '../components/ShineGame';

const LyricsPracticeShine = () => (
    <div className="app lyrics-game-page">
        <main aria-label="Shine 가사 연습 게임"><ShineGame /></main>
    </div>
);

export default LyricsPracticeShine;
